
import React from "react";
import "./Checkbox.css";

export type CheckboxProps = {
    name: string;
    choices: string[];
    choice: string | undefined;
    sorted?: boolean;
    disabled?: boolean;
    variant?: "primary" | "secondary" | "tertiary";
    size?: "sm" | "md" | "lg";
    className?: string;
    onChange: (choice: string | undefined) => void;
    children?: React.ReactNode;
};

export const Checkbox = ({
    name,
    choices,
    choice,
    sorted = false,
    disabled = false,
    variant = "primary",
    size = "sm",
    className,
    onChange,
    children,
    ...props
}: CheckboxProps & React.ComponentPropsWithoutRef<"div">) => {

    const sortedChoices = sorted ? choices.sort((a: string, b: string) => a.localeCompare(b)) : choices;

    const getVariantClass = () => {
        switch (variant) {
            case "primary":
                return "ds2-checkbox-primary";
            case "secondary":
                return "ds2-checkbox-secondary";
            case "tertiary":
                return "ds2-checkbox-tertiary";
            default:
                return "ds2-checkbox-primary";
        }
    }

    const getSizeStyles = () => {

        switch (size) {
            case "sm":
                return {height: "16px", width: "24px", minWidth: "24px", fontSize: "1rem", outline: "none"};
            case "md":
            case "lg":
            default:
                return {height: "24px", width: "40px", minWidth: "40px", fontSize: "1.25rem"};
        }
    }

    // const getInnerSizeStyles = () => {
    
    //     switch (size) {
    //         case "sm":
    //             return {padding: "0px", gap: "2px", fontSize: ".85rem"};
    //         case "md":
    //         case "lg":
    //         default:
    //             return {padding: "8px 12px", gap: "4px", fontSize: "1rem"};
    //     }
    // }
    
    return (
        <div className="ds2-checkbox">
            {sortedChoices.map((option: string, index: number) => {
                return (
                    <div 
                        key={"checkbox-" + index}
                        className="ds2-checkbox-choice"
                    >
                        <input
                            key={"checkbox-" + index}
                            name={name}
                            type="checkbox"
                            disabled={disabled} 
                            checked={choice === option}
                            className={getVariantClass() + " " + className}
                            style={{
                                ...getSizeStyles(),
                            }}
                            onChange={(event) => {
                                // alert("onChange: " + event.target.checked ? option : "undefined");
                                onChange(event.target.checked ? option : undefined);
                            }}
                            {...props} 
                        />     
                        {option}
                    </div>
                );
            })}
        </div>
    );
};